import { render, staticRenderFns } from "./LandingFixSms.vue?vue&type=template&id=5bfeeebc&scoped=true"
import script from "./LandingFixSms.vue?vue&type=script&lang=js"
export * from "./LandingFixSms.vue?vue&type=script&lang=js"
import style0 from "./LandingFixSms.vue?vue&type=style&index=0&id=5bfeeebc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfeeebc",
  null
  
)

export default component.exports